import { styled } from '@yunex/yds-react';
export var CenteredBox = styled('div')({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});
//# sourceMappingURL=CenteredBox.js.map